// This is the UpdateParamsDialog.logic.ts sibling that canon/logic-in-tsx
// requires for the non-JSX helpers pulled out of UpdateParamsDialog.tsx.
// That rule strips only the text before the first dot ("UpdateParamsDialog")
// and expects an export of that exact name; no multi-helper logic module will
// ever have one, and canonicalNamePatterns has no carve-out for the `.logic`
// suffix (unlike the `use[A-Z]` hook pattern it already recognizes).
/* eslint-disable canon/file-name-matches-primary-export -- see comment above: no export here can be named after the file's pre-dot stem by construction */
import type { CopyTarget } from "./UpdateParamsDialog";

// Обе кнопки «Скопировать» показывают один и тот же видимый текст (idle/copied/failed) —
// доступное имя называет список, чтобы кнопки различались для экранного чтеца.
const COPY_TARGET_LIST_NAMES: Record<CopyTarget, string> = {
  notFound: "ненайденные адреса",
  invalidLines: "невалидные строки",
};

/** Доступное имя кнопки «Скопировать»: видимый текст статуса + список, который она копирует. */
export function copyButtonAriaLabel(visibleLabel: string, target: CopyTarget): string {
  return `${visibleLabel} ${COPY_TARGET_LIST_NAMES[target]}`;
}
